import React, { useEffect, useRef, useState } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { Input } from 'rsuite';

interface GooglePlacesAutocompleteProps {
  value?: string;
  onChange?: (address: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

const GooglePlacesAutocomplete: React.FC<GooglePlacesAutocompleteProps> = ({
  value = '',
  onChange,
  placeholder = '請輸入地址',
  style
}) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      componentRestrictions: { country: "tw" },
      fields: ['formatted_address', 'geometry', 'name', 'place_id']
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      const place = placeAutocomplete.getPlace();
      if (place.formatted_address) {
        const address = place.formatted_address;
        setInputValue(address);
        onChange?.(address);
      }
    });
  }, [placeAutocomplete, onChange]);

  const handleInputChange = (value: string) => {
    setInputValue(value);
    onChange?.(value);
  };

  return (
    <Input
      ref={inputRef}
      value={inputValue}
      onChange={handleInputChange}
      placeholder={placeholder}
      style={style}
    />
  );
};

export default GooglePlacesAutocomplete;